import Select from "react-select";
import { useEffect, useState } from "react";
import Card from "../../../../components/layouts/Card";
import { Option } from "../../../../interfaces/Options";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import { setBooking, setError } from "../../../../redux/reducers/bookings/actions";
import { InputWrapper, SelectStyle } from "../../../../components/forms/FormComponents";
import { clearError, fieldErrorMessage, fieldHasErrors } from "../../../../helpers/errorHandler";


const BookingCreateApplicant = () => {
  const dispatch = useDispatch();
  const errors = useSelector((state: RootState) => state.booking.error);
  const userItems = useSelector((state: RootState) => state.user.users);
  const isLoading = useSelector((state: RootState) => state.booking.isLoading);
  const [userOptions, setUserOptions] = useState<Option[]>([]);
  const [applicantSelected, setApplicantSelected] = useState<Option | null>(null);
  const [applicantRoleSelected, setApplicantRoleSelected] = useState<string>('');
  const booking = useSelector((state: RootState) => state.booking.updatedBooking);

  useEffect(() => {
    const newOptions: Option[] = [];
    userItems.forEach(item => {
      if (item.id) {
        newOptions.push({
          value: item.id?.toString(),
          label: item.name
        });
      }
    });
    setUserOptions(newOptions);
  }, [userItems])
  
  const onChangeApplicantName = (e: Option | null) => {
    if (!e || !booking) return;
    clearError('id_user', errors, setError, dispatch);
    const userId = parseInt(e.value);
    setApplicantSelected(e);
    dispatch(setBooking({
      ...booking,
      id_user: userId
    }));
    setApplicantRoleSelected('Manajemen Bangunan');
  };

  return (
    <Card>
      <div className="card--title">
        <h2 className="card--title-title">Data Pemohon</h2>
        <p className="card--title-description">Data yang mengajukan peminjaman ruangan</p>
      </div>
      <div className="card--body">
        <InputWrapper hasErrors={fieldHasErrors('id_user', errors)}>
          <div className="input--field select">
            <label>Nama Pemohon</label>
            <Select
              styles={SelectStyle}
              isDisabled={isLoading}
              value={applicantSelected}
              options={userOptions}
              onChange={(e: any) => onChangeApplicantName(e)}
              menuPortalTarget={document.querySelector("body")}
            />
          </div>
          <div className="input--errors">
            { fieldErrorMessage('id_user', errors) }
          </div>
        </InputWrapper>
        <InputWrapper>
          <div className="input--field">
            <label>Divisi Pemohon</label>
            <input
              type="text"
              disabled={true}
              value={applicantRoleSelected}
              placeholder="Silahkan pilih pemohon"
            />
          </div>
        </InputWrapper>
      </div>
    </Card>
  );
}

export default BookingCreateApplicant;